/**
 * Curated palette search aliases keyed by node id.
 * Regenerate: `node scripts/generate-node-search-tags.mjs`
 */
export const NODE_SEARCH_TAGS: Readonly<Record<string, readonly string[]>> = {
  'absolute': ['absolute', 'abs', 'magnitude'],
  'add': ['add', 'plus', 'sum'],
  'arc-cosine': ['arc', 'cosine', 'acos', 'arccos'],
  'arc-sine': ['arc', 'sine', 'asin', 'arcsin'],
  'arc-tangent': ['arc', 'tangent', 'atan', 'arctan'],
  'arc-tangent-2': ['arc', 'tangent', 'atan2'],
  'arrangement-lanes': ['arrangement', 'lanes', 'regions', 'midi', 'tracks'],
  'arrangement-notes': ['arrangement', 'notes', 'midi', 'piano'],
  'bayer-dither': ['bayer', 'dither', 'ordered', 'halftone'],
  'bezier-curve': ['bezier', 'curve', 'easing', 'interpolation', 'remap'],
  'blend': ['blend', 'mix', 'lerp', 'overlay', 'multiply', 'screen', 'composite', 'photoshop'],
  'bloom-sphere': ['bloom', 'sphere', 'glow', 'lattice', '3d'],
  'blur': ['blur', 'gaussian', 'soften', 'defocus'],
  'bokeh': ['bokeh', 'defocus', 'lens', 'circles'],
  'bokeh-point': ['bokeh', 'point', 'lens', 'defocus', 'lights'],
  'boundary-shutter-rays': ['boundary', 'shutter', 'rays', 'midi', 'arrangement', 'pattern', 'section'],
  'box-torus-sdf': ['box', 'torus', 'primitives', 'primitive', 'sdf', 'mesh'],
  'brick-tiling': ['brick', 'tiling', 'tile', 'repeat', 'offset'],
  'ceil': ['ceil', 'ceiling', 'round', 'integer'],
  'cellular-slip': ['cellular', 'slip', 'voronoi', 'glass', 'distort', 'cells'],
  'chord-voronoi-bloom': ['chord', 'voronoi', 'bloom', 'midi', 'arrangement', 'pattern', 'harmonic', 'cells'],
  'chromatic-aberration': ['chromatic', 'aberration', 'dispersion', 'rgb', 'lens'],
  'circle-inversion': ['circle', 'inversion', 'invert', 'bubble', 'conformal', 'distort', 'uv'],
  'clamp': ['clamp', 'limit', 'bounds', 'range'],
  'clamp-01': ['clamp', '01', 'saturate', 'limit'],
  'color-gradient': ['color', 'gradient', 'spatial', 'sky', 'ramp', 'oklch', 'position', 'mask'],
  'color-grading': ['color', 'grading', 'grade', 'levels', 'curves'],
  'color-lut': ['color', 'lut', 'colormap', 'viridis', 'turbo', 'preset', 'heatmap', 'scientific'],
  'combine-vector': ['combine', 'vector', 'pack', 'vec2', 'vec3', 'vec4', 'merge', 'layers'],
  'compare': ['compare', 'greater', 'less', 'equal', 'condition'],
  'constant-float': ['constant', 'float', 'scalar', 'number', 'value'],
  'constant-vec2': ['constant', 'vec2', 'vector', 'uv', 'xy'],
  'constant-vec3': ['constant', 'vec3', 'vector', 'rgb', 'color', 'xyz'],
  'constant-vec4': ['constant', 'vec4', 'vector', 'rgba', 'xyzw'],
  'cosine': ['cosine', 'cos', 'wave'],
  'crease-fold': ['crease', 'fold', 'mirror', 'hinge', 'distort'],
  'crepuscular-rays': ['crepuscular', 'rays', 'godrays', 'sunbeams', 'light', 'volumetric'],
  'cross-product': ['cross', 'product'],
  'cubic-curl-noise': ['cubic', 'curl', 'noise', 'flow', 'vector'],
  'disco-pattern': ['disco', 'pattern', 'tiles', 'color'],
  'displace': ['displace', 'offset', 'translate', 'warp', 'uv'],
  'displacement-3d': ['displacement', 'displace', '3d', 'surface', 'noise'],
  'distance': ['distance', 'dist', 'separation'],
  'divide': ['divide', 'division', 'ratio'],
  'dot-product': ['dot', 'product', 'inner'],
  'dots': ['dots', 'dot', 'grid', 'stipple', 'points', 'halftone'],
  'drive-home-lights': ['drive', 'home', 'lights', 'street', 'night', 'bokeh'],
  'duration-comet-trails': ['duration', 'comet', 'trails', 'midi', 'arrangement', 'pattern', 'trail', 'onset'],
  'edge-detection': ['edge', 'detection', 'sobel', 'edges', 'outline', 'contour'],
  'ether-sdf': ['ether', 'fractal', 'organic', 'sdf'],
  'exponential': ['exponential', 'exp', 'pow'],
  'final-output': ['final', 'output', 'render', 'present', 'screen'],
  'floor': ['floor', 'flooring', 'round', 'integer'],
  'flow-field-pattern': ['flow', 'field', 'pattern', 'streamlines', 'vector'],
  'fract': ['fract', 'fractional', 'decimal', 'repeat'],
  'fractal': ['fractal', 'mandelbrot', 'julia', '2d', 'iteration'],
  'fragment-coordinates': ['fragment', 'coordinates', 'frag', 'coords', 'pixel', 'screen', 'glsl'],
  'generic-raymarcher': ['generic', 'raymarcher', 'raymarch', 'sdf', '3d', 'distance', 'render'],
  'glass-shell': ['glass', 'shell', 'transparent', 'sdf'],
  'glow-bloom': ['glow', 'bloom', 'halation', 'bright'],
  'gradient': ['gradient', 'ramp', 'lerp', 'color', 'blend'],
  'hash32': ['hash32', 'hash', 'random', 'noise', 'seed'],
  'hex-prism-sdf': ['hex', 'prism', 'sdf', '3d'],
  'hexagonal-grid': ['hexagonal', 'grid', 'hex', 'tile', 'pattern'],
  'infinite-zoom': ['infinite', 'zoom', 'tunnel', 'scale', 'loop'],
  'inflated-icosahedron': ['inflated', 'icosahedron', 'polyhedron', '3d', 'mesh'],
  'iridescent-tunnel': ['iridescent', 'tunnel', '3d', 'color'],
  'iterated-inversion': ['iterated', 'inversion', 'spotlight', 'fractal', 'fold'],
  'julia-slab-sdf': ['julia', 'slab', 'fractal', '2d', 'sdf'],
  'kaleidoscope': ['kaleidoscope', 'mirror', 'symmetry', 'segments', 'radial'],
  'kifs-sdf': ['kifs', 'fractal', 'fold', 'sdf'],
  'length': ['length', 'magnitude', 'norm'],
  'lerp': ['lerp', 'mix', 'blend', 'interpolate'],
  'lighting-shading': ['lighting', 'shading', 'light', 'shade', 'diffuse', 'specular'],
  'look-at-camera': ['look', 'at', 'camera', 'lookat', '3d', 'view'],
  'mandelbox-sdf': ['mandelbox', 'fractal', 'fold', 'sdf'],
  'mandelbulb-sdf': ['mandelbulb', 'fractal', 'bulb', '3d', 'sdf'],
  'mask-composite-float': ['mask', 'composite', 'float', 'bw', 'alpha'],
  'mask-composite-vec2': ['mask', 'composite', 'vec2', 'uv'],
  'mask-composite-vec3': ['mask', 'composite', 'vec3', 'color'],
  'max': ['max', 'maximum', 'upper'],
  'menger-sponge-sdf': ['menger', 'sponge', 'fractal', 'sdf'],
  'metaballs': ['metaballs', 'blob', 'merge', 'sdf', 'organic'],
  'min': ['min', 'minimum', 'lower'],
  'mix': ['mix', 'lerp', 'blend', 'interpolate'],
  'mixed-wave-signal': ['mixed', 'wave', 'signal', 'audio', 'lfo', 'modulation'],
  'mobius-portal': ['mobius', 'portal', 'bius', 'conformal', 'disk', 'distort', 'lens'],
  'modulo': ['modulo', 'mod', 'remainder'],
  'multiply': ['multiply', 'times', 'product'],
  'natural-logarithm': ['natural', 'logarithm', 'log', 'ln'],
  'negate': ['negate', 'invert', 'sign'],
  'noise': ['noise', 'fbm', 'perlin', 'simplex', 'random', 'procedural'],
  'normal-mapping': ['normal', 'mapping', 'bump', 'lighting', 'surface'],
  'normalize': ['normalize', 'unit', 'direction'],
  'note-gravity-warp': ['note', 'gravity', 'warp', 'midi', 'arrangement', 'pattern', 'distort'],
  'note-ripple-field': ['note', 'ripple', 'field', 'midi', 'arrangement', 'pattern', 'onset'],
  'oklch-color': ['oklch', 'color', 'perceptual', 'picker'],
  'oklch-color-map': ['oklch', 'color', 'map', 'colormap', 'gradient', 'palette', 'smooth', 'stepped', 'bands'],
  'one-minus': ['one', 'minus', 'invert', 'reverse'],
  'orbit-camera': ['orbit', 'camera', '3d', 'view'],
  'oscillator-2d': ['oscillator', 'audio', 'lfo', 'xy', 'modulation'],
  'particle-system': ['particle', 'system', 'speckle', 'grain', 'dust', 'particles'],
  'path-drive': ['path', 'drive', 'audio', 'envelope', 'automation'],
  'pitch-class-compass': ['pitch', 'class', 'compass', 'wheel', 'midi', 'arrangement', 'pattern', 'harmonic', 'chord'],
  'pixelize': ['pixelize', 'pixel', 'mosaic', 'quantize', 'block', 'grid', 'distort', 'uv'],
  'plane-grid': ['plane', 'grid', 'floor', 'lines'],
  'plane-project': ['plane', 'project', 'projection', 'camera', 'uv', '3d'],
  'polar-coordinates': ['polar', 'coordinates', 'coords', 'angle', 'radius'],
  'power': ['power', 'exponent', 'pow'],
  'quad-warp': ['quad', 'warp', 'perspective', 'corner', 'pin'],
  'radial-pulse': ['radial', 'pulse', 'beat', 'wave'],
  'radial-rays': ['radial', 'rays', 'godrays', 'sun'],
  'radial-repeat-sdf': ['radial', 'repeat', 'polar', 'sdf', 'array'],
  'radial-uv-warp': ['radial', 'uv', 'warp', 'bulge', 'lens'],
  'rain-drops': ['rain', 'drops', 'water', 'weather'],
  'reciprocal': ['reciprocal', 'inverse', 'divide'],
  'reflect': ['reflect', 'mirror', 'bounce'],
  'refract': ['refract', 'snell', 'glass'],
  'repeated-hex-prism-sdf': ['repeated', 'hex', 'prism', 'repeat', 'sdf', 'array'],
  'resolution': ['resolution', 'size', 'viewport', 'dimensions', 'screen'],
  'rgb-separation': ['rgb', 'separation', 'channel', 'offset', 'glitch'],
  'rhythm-stripe-field': ['rhythm', 'stripe', 'field', 'wavefield', 'midi', 'wave', 'arrangement', 'pattern', 'density', 'warp'],
  'rings': ['rings', 'concentric', 'circle', 'radial', 'lines'],
  'ripple': ['ripple', 'wave', 'water', 'distort', 'concentric'],
  'round': ['round', 'rounding', 'nearest', 'integer'],
  'saturate': ['saturate', 'clamp', 'limit', '01'],
  'scanlines': ['scanlines', 'crt', 'tv', 'lines', 'interlace'],
  'select': ['select', 'branch', 'if', 'switch', 'choose'],
  'shapes-2d': ['shapes', 'circle', 'rectangle', 'sdf', '2d', 'mask'],
  'sierpinski-tetra-sdf': ['sierpinski', 'tetra', 'tetrahedron', 'fractal', 'sdf'],
  'sign': ['sign', 'signum', 'positive', 'negative'],
  'sine': ['sine', 'sin', 'wave', 'oscillator'],
  'sky-dome': ['sky', 'dome', 'skydome', 'sun', 'atmosphere', 'background'],
  'smoothstep': ['smoothstep', 'ease', 'smooth', 'hermite'],
  'sphere-raymarch': ['sphere', 'raymarch', '3d', 'sdf'],
  'spherical-fibonacci': ['spherical', 'fibonacci', 'sphere', 'points', 'distribution'],
  'split-vector': ['split', 'vector', 'unpack', 'decompose'],
  'square-root': ['square', 'root', 'sqrt'],
  'star-shape-2d': ['star', 'shape', 'starflower', 'flower', '2d'],
  'step': ['step', 'threshold', 'hard'],
  'streak': ['streak', 'spot', 'flare', 'lens'],
  'stripes': ['stripes', 'lines', 'bands', 'parallel', 'pattern'],
  'subtract': ['subtract', 'minus', 'difference'],
  'swizzle': ['swizzle', 'shuffle', 'reorder', 'channels'],
  'tangent': ['tangent', 'tan'],
  'time': ['time', 'clock', 'seconds', 'animation', 'timeline'],
  'tone-mapping': ['tone', 'mapping', 'hdr', 'exposure', 'reinhard', 'filmic'],
  'track-halo-lattice': ['track', 'halo', 'lattice', 'midi', 'arrangement', 'pattern'],
  'transform': ['transform', 'scale', 'rotate', 'translate', '2d', 'matrix'],
  'triangle-grid': ['triangle', 'grid', 'triangular', 'mesh', 'tiling', 'pattern'],
  'truncate': ['truncate', 'trunc', 'integer', 'floor'],
  'turbulence': ['turbulence', 'noise', 'warp', 'distort', 'fbm'],
  'uv-band-shift': ['uv', 'band', 'shift', 'bands', 'offset', 'slice'],
  'uv-block-glitch': ['uv', 'block', 'glitch', 'blocks', 'digital', 'corrupt'],
  'uv-coordinates': ['uv', 'coordinates', 'coords', 'texture'],
  'velocity-spark-grid': ['velocity', 'spark', 'grid', 'midi', 'arrangement', 'pattern', 'rhythm', 'onset'],
  'vector-field': ['vector', 'field', 'flow', 'direction', 'distort', 'warp'],
  'volume-rays': ['volume', 'rays', 'cloud', 'fog', 'volumetric', 'density'],
  'voronoi-noise': ['voronoi', 'noise', 'cells', 'worley', 'cellular'],
  'vortex': ['vortex', 'twist', 'swirl', 'rotate', 'distort'],
  'wake-smear': ['wake', 'smear', 'trail', 'datamosh', 'motion', 'distort', 'drag'],
  'warp-terrain': ['warp', 'terrain', 'height', 'landscape', 'fbm'],
};
